<template>
  <v-dialog
    :value="value"
    max-width="600px"
    @input="$emit('input', $event)"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title>Edit Ingredient</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="editName"
          label="Ingredient name"
          autofocus
          @keyup.enter="save"
        />
        <p class="caption mb-2">
          The part of the name before the first comma is what customers see on the meal label.
          The full name is shown to the kitchen prep team.
          For example, "tofu, chopped and fried" appears as just "tofu" on the customer ingredient
          list, while the kitchen sees the full "tofu, chopped and fried".
        </p>
        <v-card outlined class="mb-2">
          <v-card-subtitle class="pb-0 caption">Customer label will show</v-card-subtitle>
          <v-card-text><strong>{{ customerName }}</strong></v-card-text>
        </v-card>
        <v-card outlined class="mb-6">
          <v-card-subtitle class="pb-0 caption">Kitchen prep team will see</v-card-subtitle>
          <v-card-text><strong>{{ customerName }}</strong>{{ kitchenRest }}</v-card-text>
        </v-card>
        <IngredientDescriptionField
          v-model="editDescription"
          :name="editName"
          :exclude-foodid="foodid"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :disabled="!canSave" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IngredientDescriptionField, {formatDescription} from '@/components/IngredientDescriptionField';

export default {
  name: 'EditIngredientNameDialog',
  components: {IngredientDescriptionField},
  props: {
    value: {type: Boolean, required: true},
    name: {type: String, default: ''},
    description: {type: String, default: ''},
    foodid: {type: Number, default: null}
  },
  data() {
    return {
      editName: this.name,
      editDescription: this.description
    }
  },
  watch: {
    value(showing) {
      if (showing) {
        this.editName = this.name;
        this.editDescription = this.description;
      }
    },
    name(v) {
      this.editName = v;
    },
    description(v) {
      this.editDescription = v;
    }
  },
  computed: {
    customerName() {
      return (this.editName || '').split(',')[0].trim().toLowerCase();
    },
    kitchenRest() {
      const [first, ...rest] = (this.editName || '').split(',');
      return rest.length ? (this.editName || '').substring(first.length) : '';
    },
    canSave() {
      return !!(this.editName || '').trim();
    }
  },
  methods: {
    save() {
      const name = (this.editName || '').trim();
      if (!name) {
        return;
      }
      this.$emit('save', {
        fooddescriptionsimple: name,
        fooddescription: formatDescription(this.editDescription)
      });
      this.$emit('input', false);
    },
    cancel() {
      this.$emit('input', false);
    }
  }
}
</script>
